<template>
  <div class="is-marginless is-paddingless section section-details" v-if="remiseBancaire">
    <div class="entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">
                {{ importFunction.formatCodeRemiseBancaire(
                remiseBancaire.num, remiseBancaire.nom, constantes.SENS_VENTE) }}
              </h1>
              <app-breadcrumb :breadcrumb="breadcrumb"/>
            </div>
          </div>
        </div>
        <a ref="lienDownload"></a>
        <div class="level-right">
          <div class="buttons">
            <button v-if="remiseBancaire.etat === constantes.ENCOURS"
              class="button is-addOrEdit"
                    :class="{'button-access-no-permission' :
                    !checkPermissions(constantes.REMISES_BANCAIRES.maj)}"
                    @click="
               checkPermissions(constantes.REMISES_BANCAIRES.maj) ?
               $router.push({ name: 'm.bodac.remises_bancaires-editionRemise',
               params: { id: remiseBancaire.id }}) : showPopUp()">
              {{ $t('general.button.edit') }}
            </button>
            <button class="button is-addOrEdit" v-if="detailRemiseBancaire.length !== 0"
                    :class="{'button-access-no-permission' :
                    !checkPermissions(constantes.REMISES_BANCAIRES.maj)}"
                    @click="
               checkPermissions(constantes.REMISES_BANCAIRES.maj)
               ? popUpEtatRemiseBancaire = true : showPopUp()">
              {{ remiseBancaire.etat === constantes.ENCOURS ? $t('remiseBancaire.validation')
              : $t('remiseBancaire.devalidation')}}
            </button>
            <button class="button"
                    v-if="remiseBancaire.etat !== constantes.ENCOURS">
              <b-dropdown position="is-bottom-left" aria-role="list">
                <a slot="trigger">
                  <b-icon
                    type="is-default"
                    icon="dots-vertical">
                  </b-icon>
                </a>
                <b-dropdown-item
                  @click="checkPermissions(constantes.REMISES_BANCAIRES.maj) ?
                  generateEcritureComptable() : showPopUp()"
                  v-if="remiseBancaire.etat !== constantes.ENCOURS">
                  {{ $t('remiseBancaire.generateEcriture') }}
                </b-dropdown-item>
                <b-dropdown-item class="has-text-left"
                  @click="checkPermissions(constantes.REMISES_BANCAIRES.maj) ?
                  generatePrelevement() : showPopUp()"
                  v-if="isPrelevementSepa">
                  {{ $t('remiseBancaire.generatePrelevement') }}
                </b-dropdown-item>
              </b-dropdown>
            </button>
            <button class="button"
                    @click="$refs.dropdownEdition.toggle()">
              <div>
                <b-icon icon="file-download" class="mgr-10px" type="is-default"></b-icon>
                <b-dropdown ref="dropdownEdition" position="is-bottom-left">
                  <div slot="trigger">
                    <b-icon icon="chevron-down"
                            class="has-text-secondary-icon">
                    </b-icon>
                  </div>
                  <b-dropdown-item
                    @click="checkPermissions(constantes.REMISES_BANCAIRES.editer)
                    ? edition('Pdf') : showPopUp()">
                    {{ $t('general.popUpEdition.type.pdf') }}
                  </b-dropdown-item>
                  <b-dropdown-item
                    @click="checkPermissions(constantes.REMISES_BANCAIRES.editer)
                    ? edition('Docx') : showPopUp()">
                    {{ $t('general.popUpEdition.type.docx') }}
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
    <b-modal v-model="popUpEtatRemiseBancaire" has-modal-card class="modal"
              @close="reinitiliseErrorPopUp()">
      <app-pop-up-prevention  :messHeader="messHeaderRemise"
                              :messFooter="messFooterRemise"
                              :cancel="cancelPopupRemise"
                              :validate="validatePopupRemise"
                              oncancel="popUpEtatRemiseBancaire = false"
                              :isErrorPopup.sync="isErrorPopup"
                              :messagesPopup="messagesErrorPopUp"
                              @no="closePopUp()"
                              @yes="changementStatusRemise()">
      </app-pop-up-prevention>
    </b-modal>
    <error-msg-component :messages="messages"
                         :messagesChampsVide="messagesChampsVide"
                         :champsVide="champsVide"
                         :error="error"
                         class="mgt-20px"
                         :title="'general.problemOccurred'"
                         :withEmplyFields="true"
                         @close="error = $event"/>
    <div class="mgt-20px">
      <div class="tab is-marginless">
        <ul>
          <li @click="activeTab = 'appRemiseBancaire'"
              :class="{'is-active': activeTab === 'appRemiseBancaire'}">
            {{ $t('remiseBancaire.onglet.remiseBancaire')}}
          </li>
          <li v-show = "remiseBancaire.domiciliationBancaire.interfaceComptable"
          @click="activeTab = 'ecrituresComptaDetail'"
              :class="[
                {'is-active': activeTab === 'ecrituresComptaDetail'},
                {'text-access-no-permission pointer-events-none': detailRemiseBancaire.length === 0}
                ]">
            {{ $t('remiseBancaire.onglet.ecritureCompta')}}
          </li>
          <li @click="activeTab = 'fichierPrelevement'"
              :class="{'is-active': activeTab === 'fichierPrelevement'}"
              v-if="isPrelevementSepa">
            {{ $t('remiseBancaire.onglet.fichierPrelevement')}}
          </li>
        </ul>
      </div>
      <div>
        <component :is="activeTab"
                   :isDetail="true"
                   :detailRemiseBancaire="detailRemiseBancaire"
                   @updateMouvementClient="updateMouvementClient"
                   :remiseBancaire="remiseBancaire"
                   ref="componentChild"
                   :dateDernierExport="remiseBancaire.dernierExportComptable"
                   :ecritures="ecritures"/>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import edition from '@/api/edition/index';
import formatCodeRemiseBancaire from '@/services/remiseBancaire/creationCodeRemiseBancaire';
import translate from '@/services/reglement/validation/champsReglementTranslator';
import { getByRemiseBancaire } from '@/api/mouvementClient/index';
import validationRemise from '@/services/remiseBancaire/validation/validationRemiseBancaire';
import validationGeneral from '@/services/validation/validation';
import messageErreur from '@/services/general/messageErreur';
import breadcrumb from '@/components/general/breadcrumb';
import inProgress from '@/services/general/inProgress';
import {
  valid as validRemiseBancaire,
  unValid as unvalidRemiseBancaire,
  get, prelevementSEPA,
} from '@/api/remiseBancaire/index';
import messageSucces from '@/services/general/messageSucces';
import { ENCOURS, VALIDE, TYPE_EDITION_REMISE } from '@/configuration/remiseBancaire/remiseBancaireConf';
import { REMISES_BANCAIRES } from '@/configuration/permissionsBodacConf';
import popUpSuppression from '@/components/general/popUpPrevention';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import appRemiseBancaire from '@/components/remiseBancaire/remiseBancaire';
import ecrituresComptaDetail from '@/components/commun/ecritureComptable/ecrituresComptaDetail';
import {
  generateByRemiseBancaire,
  getByRemiseBancaire as getEcritureByRemiseBancaire,
} from '@/api/compta/ifEcriture/index';
import { SENS_VENTE } from '@/configuration/devisConf';
import { TYPE_REGLEMENT } from '@/configuration/compta/ecritureConf';
import { checkExercice } from '@/api/compta/exerciceComptable/index';
import validationEcriture from '@/services/ecritureComptable/validation';
import validationPrelevementSepa from '@/services/remiseBancaire/validation/validationPrelevementSepa';
import fichierPrelevement from '@/components/remiseBancaire/fichierPrelevement';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';

const permissions = createNamespacedHelpers('permissions');
const Parametres = createNamespacedHelpers('parametres');

export default {
  data() {
    return {
      popUpEtatRemiseBancaire: false,
      detailRemiseBancaire: [],
      messages: [],
      champsVide: [],
      messagesChampsVide: [],
      error: false,
      isErrorPopup: false,
      messagesErrorPopUp: [],
      importFunction: {
        formatCodeRemiseBancaire,
      },
      activeTab: 'appRemiseBancaire',
      remiseBancaire: null,
      constantes: {
        SENS_VENTE,
        REMISES_BANCAIRES,
        ENCOURS,
      },
      exerciceOk: true,
      errorsExercice: '',
      ecritures: [],
    };
  },
  components: {
    appBreadcrumb: breadcrumb,
    routerLinkBlank,
    appPopUpPrevention: popUpSuppression,
    appRemiseBancaire,
    ecrituresComptaDetail,
    fichierPrelevement,
    errorMsgComponent,
  },
  methods: {
    inProgress(message) {
      inProgress(this.$i18n, message);
    },
    ...permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    loadError(response) {
      this.champsVide = [];
      this.messagesChampsVide = [];
      this.messages = validationRemise(response, this.constantes.SENS_VENTE);
      validationGeneral(this.$i18n, response, this.champsVide, this.messages,
        this.messagesChampsVide, translate);
      this.error = true;
    },
    async updateMouvementClient() {
      const detailRemiseBancaire = (await getByRemiseBancaire(this.remiseBancaire.id)).data.result;
      detailRemiseBancaire.forEach((el) => {
        el.selected = false;
      });
      this.detailRemiseBancaire = detailRemiseBancaire;
    },
    async generateEcritureComptable() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await generateByRemiseBancaire({
          referencePieceId: this.remiseBancaire.id,
          typeEcriture: TYPE_REGLEMENT,
        });
        this.ecritures = (await getEcritureByRemiseBancaire(
          this.remiseBancaire.id,
          this.constantes.SENS_VENTE,
        )).data.result;
        messageSucces(this.$t('remiseBancaire.messages.successGenerateEcriture'));
      } catch (e) {
        messageErreur(this.$i18n);
        throw (e);
      } finally {
        loadingComponent.close();
      }
    },
    changementStatusRemise() {
      if (this.remiseBancaire.etat === ENCOURS) this.validationRemise();
      else this.devalidationRemise();
    },
    async devalidationRemise() {
      this.isErrorPopup = false;
      this.messagesErrorPopUp = [];
      const loadingComponent = this.$buefy.loading.open();
      try {
        await unvalidRemiseBancaire(this.$route.params.id);
        messageSucces(this.$t('devalidationRemiseBancaire.messages.success'));
        this.popUpEtatRemiseBancaire = false;
        this.remiseBancaire = (await get(this.$route.params.id)).data.result;
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        if (e.response && e.response.data.error) {
          this.isErrorPopup = true;
          this.messagesErrorPopUp = validationRemise(e.response, this.constantes.SENS_VENTE);
        } else {
          messageErreur(this.$i18n);
        }
        throw e;
      }
    },
    async validationRemise() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await validRemiseBancaire(this.$route.params.id);
        messageSucces(this.$t('validationRemiseBancaire.messages.success'));
        this.popUpEtatRemiseBancaire = false;
        this.remiseBancaire = (await get(this.$route.params.id)).data.result;
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        if (e.response && e.response.data.error) {
          this.loadError(e.response);
        } else {
          messageErreur(this.$i18n);
        }
        throw e;
      }
    },
    reinitiliseErrorPopUp() {
      this.isErrorPopup = false;
      this.messagesErrorPopUp = [];
    },
    closePopUp() {
      this.popUpEtatRemiseBancaire = false;
      this.reinitiliseErrorPopUp();
    },
    async edition(format) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const response = await edition({
          ids: [this.remiseBancaire.id],
          extension: format,
          typeDonnee: TYPE_EDITION_REMISE,
        });
        const link = this.$refs.lienDownload;
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
    async generatePrelevement() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.error = false;
        this.messages = [];
        this.messagesChampsVide = [];
        this.champsVide = [];
        await prelevementSEPA(this.remiseBancaire.id);
        messageSucces(this.$t('remiseBancaire.messages.successGeneratePrelevement'));
        if (this.activeTab === 'fichierPrelevement') {
          await this.$refs.componentChild.updateAttachement();
        }
        loadingComponent.close();
      } catch (e) {
        if (e.response && e.response.data.error) {
          validationPrelevementSepa(e.response, this.messages);
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, null);
          this.error = true;
          loadingComponent.close();
          return;
        }
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
  },
  computed: {
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    typeRemise() {
      return this.remiseBancaire.etat === ENCOURS ? 'validationRemiseBancaire' : 'devalidationRemiseBancaire';
    },
    messHeaderRemise() {
      const typeRemise = this.typeRemise;
      return this.$t(`${typeRemise}.delete`);
    },
    messFooterRemise() {
      return this.errorsExercice;
    },
    cancelPopupRemise() {
      const typeRemise = this.typeRemise;
      return this.$t(`${typeRemise}.no`);
    },
    validatePopupRemise() {
      const typeRemise = this.typeRemise;
      return this.$t(`${typeRemise}.yes`);
    },
    breadcrumb() {
      const output = [
        { title: this.$t('remiseBancaire.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('remiseBancaire.titre'), route: { name: 'l.bodac.remises_bancaires' }, isActive: false },
        {
          title: formatCodeRemiseBancaire(
            this.remiseBancaire.num, this.remiseBancaire.nom, SENS_VENTE,
          ),
          route: { name: 'c.bodac.remises_bancaires' },
          isActive: true,
        },
      ];
      return output;
    },
    isPrelevementSepa() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.prelevementSepa.key)
            && this.remiseBancaire.modeReglement.prelevement
            && this.remiseBancaire.etat === VALIDE;
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    const id = this.$route.params.id;
    try {
      this.remiseBancaire = (await get(id)).data.result;
      this.remiseBancaire.dateRemise = new Date(this.remiseBancaire.dateRemise);
      const detailRemiseBancaire = (await getByRemiseBancaire(this.remiseBancaire.id)).data.result;
      detailRemiseBancaire.forEach((el) => {
        el.selected = false;
        el.montant = el.credit - el.debit;
      });
      this.detailRemiseBancaire = detailRemiseBancaire;
      this.ecritures = (await getEcritureByRemiseBancaire(
        this.remiseBancaire.id,
        this.constantes.SENS_VENTE,
      )).data.result;
      this.setInformationPage(this.$t('pageGeneral.detail', { item: formatCodeRemiseBancaire(this.remiseBancaire.num, this.remiseBancaire.nom, SENS_VENTE) }));
      await checkExercice(this.remiseBancaire.societeId, this.remiseBancaire.dateRemise)
        .then(response => {
          this.exerciceOk = response.data.result.state;
          if (response.data.result.errors !== null && response.data.result.errors.length >= 1) {
            const messages = [];
            validationEcriture(this.$i18n, response.data.result.errors, messages);
            this.errorsExercice = this.$i18n.t(messages[0].message, messages[0].parametres);
          }
        });
      await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.prelevementSepa.key]);
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      if (e.response.data.error) {
        this.loadError(e.response);
      } else {
        messageErreur(this.$i18n);
      }
      throw (e);
    }
  },
};
</script>

<style scoped>

</style>
